import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";

const pathBase = `/staff/`;
const pathById = `${pathBase}:staffId/`;

export type IStaffPathParam = IExtractParams<typeof pathById>;

export const staffs = {
  getAll: () => generatePath(pathBase, null),
  post: () => generatePath(pathBase, null),
  get: (param: IStaffPathParam) => generatePath(pathById, param),
  put: (param: IStaffPathParam) => generatePath(pathById, param),
  patch: (param: IStaffPathParam) => generatePath(pathById, param),
  delete: (param: IStaffPathParam) => generatePath(pathById, param),
};
